const videoElements = document.querySelectorAll(".image-text_player");

if (videoElements) {
  videoElements.forEach((videoElement) => {
    videoElement.addEventListener("click", function (event) {
      const videoPreviewElements = this.querySelectorAll(
        ".image-text_image.with-video, .btn_play-button"
      );
      const video = this.querySelector(".video");

      videoPreviewElements.forEach((previewElement) => {
        previewElement.classList.add("is-removed");
      });

      video.classList.add("is-active");
      video.setAttribute("src", video.dataset.src);
    });
  });
}
